<template>
    <div :style="{backgroundColor:backgroundColor}" class="firsecond_content">
        <div class="middletf">
            <div :style="{backgroundColor: backgroundColor == '#F6F9FF' ? '#fff' : 'inherit'}" class="mySecond" @click="mysecondJump('1')">
                <img class="my_img" src="./../../images/first02.png" alt="版权存证" />
                <p class="my_p1">版权存证</p>
                <p class="my_p2">直通互联网法院</p>
                <p class="my_p3">司法认可的区块链存证</p>
                <div class="jiantou">
                    <img src="./../../images/first01.png" alt='版权登记'/>
                </div>
            </div>
            <div :style="{backgroundColor: backgroundColor == '#F6F9FF' ? '#fff' : 'inherit'}" class="mySecond" @click="mysecondJump('5')">
                <img class="my_img" src="./../../images/newdengji.png" alt="版权登记" />
                <p class="my_p1">版权登记</p>
                <p class="my_p2">申请版权局</p>
                <p class="my_p3">颁发的版权登记证书</p>
                <div class="jiantou">
                    <img src="./../../images/first01.png" alt='版权登记'/>
                </div>
            </div>
            <div :style="{backgroundColor: backgroundColor == '#F6F9FF' ? '#fff' : 'inherit'}" class="mySecond" @click="mysecondJump('2')">
                <img class="my_img" src="./../../images/first03.png" alt="版权监测" />
                <p class="my_p1">版权监测</p>
                <p class="my_p2">文字、图片、监测</p>
                <p class="my_p3">高准确度、操作简便</p>
                <div class="jiantou">
                    <img src="./../../images/first01.png" alt='版权登记'/>
                </div>
            </div>
            <div :style="{backgroundColor: backgroundColor == '#F6F9FF' ? '#fff' : 'inherit'}" class="mySecond" @click="mysecondJump('3')">
                <img class="my_img" src="./../../images/first04.png" alt="版权取证" />
                <p class="my_p1">版权取证</p>
                <p class="my_p2">区块链上链记录、</p>
                <p class="my_p3">取证证据直通互联网法院</p>
                <div class="jiantou">
                    <img src="./../../images/first01.png" alt='版权登记'/>
                </div>
            </div>
            <div :style="{backgroundColor: backgroundColor == '#F6F9FF' ? '#fff' : 'inherit'}" class="mySecond" @click="mysecondJump('4')">
                <img class="my_img" src="./../../images/first05.png" alt="法律服务" />
                <p class="my_p1">法律服务</p>
                <p class="my_p2">法律维权服务</p>
                <p class="my_p3">互联网法院在线办理</p>
                <div class="jiantou">
                    <img src="./../../images/first01.png" alt='版权登记'/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name:'firsecond',
        props:{
            backgroundColor:{
                type:String,
                default:'#fbfdff'
            },
        },
        data(){
            return{

            }
        },
        methods:{
            mysecondJump(number){
                switch(number){
                    case '1':
                        this.$router.push({ path:'/cunzheng.html' })
                        // window.location.href = "https://previp.bqj.cn/cunzheng.html"
                        break;
                    case '2':
                        this.$router.push({ path:'/jiance.html' })
                        // window.location.href = "https://previp.bqj.cn/jiance.html"
                        break;
                    case '3':
                        this.$router.push({ path:'/evidence' })
                        // window.location.href = "https://previp.bqj.cn/quzheng.html"
                        break;
                    case '4':
                        this.$router.push({ path:'/fuwu.html' })
                        // window.location.href = "https://previp.bqj.cn/flfw.html"
                        break;
                    case '5':
                        // this.$router.push({ path:'/copyrightRegistration' })
                        // window.location.href = "https://www.bqj.cn/copyrightRegistration"
                        window.open('/copyrightRegistration', '_blank')
                        // window.open('/banquanchaxun.html', '_blank')
                        break;
                    default:
                        break;
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .firsecond_content{
        height:541px;
        background:rgba(251,253,255,1);
        .middletf{
            width:1334px;
            margin:0 auto;
            display: flex;
            justify-content: flex-start;
            .mySecond{
                display:flex;
                flex-direction: column;
                // justify-content: center;
                align-items: center;
                width:315px;
                height:414px;
                margin-top:63px;
                margin-bottom:64px;
                margin-right:25px;
                .my_img{
                    width:140px;
                    height:140px;
                    margin-top:39px;
                    margin-bottom:39px;
                }
                .my_p1{
                    height:30px;
                    font-size:22px;
                    font-weight:bold;
                    color:rgba(51,51,51,1);
                    line-height:30px;
                }
                .my_p2{
                    height:22px;
                    font-size:16px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    line-height:22px;
                    margin-top:14px;
                    margin-bottom:8px;
                }
                .my_p3{
                    height:22px;
                    font-size:16px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                    line-height:22px;
                    margin-bottom:35px;
                }
                .jiantou{
                    width:30px;
                    height:30px;
                    // background:rgba(255,216,0,1);
                    vertical-align: middle;
                    text-align:center;
                    line-height:30px;
                    border-radius:15px;
                    img{
                        width:14px;
                        height:10px;
                        vertical-align: middle;
                        text-align:center;
                    }
                }
                &:hover{
                    width:315px;
                    height:414px;
                    background:rgba(255,255,255,1);
                    /*box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);*/

                    box-shadow: 0px 2px 40px 0px rgba(29, 31, 108, 0.1);
                    cursor:pointer;
                    .jiantou{
                        background:rgba(255,216,0,1);
                    }
                }
            }
        }
    }
</style>